import dayjs from 'dayjs';
import { isInvalidValue } from "../../../utils/date";
export function dateToDayjs(time, format) {
    if (isInvalidValue(time)) {
        return undefined;
    }
    var dayjsInstance;
    if (typeof time === 'number') {
        // If the input is a timestamp
        dayjsInstance = dayjs(time);
    }
    else if (typeof time === 'string') {
        // If the input is in the format "HH:mm:ss"
        dayjsInstance = dayjs(time, format || 'HH:mm:ss');
    }
    else if (time instanceof Date) {
        // If the input is a Date object
        dayjsInstance = dayjs(time);
    }
    else {
        throw new Error('Invalid input format');
    }
    return dayjsInstance.toDate();
}
